import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseFeeTemplatesProps<T> = {
  filters?: {
    search?: string
    page?: number
    category?: string
    pageSize?: number
  }
  mapper?: (data: any) => T,
}

export const useFeeTemplates = <T,>({
  filters: { search = '', page, category, pageSize } = {},
  mapper = Mapper.default<T>(),
}: UseFeeTemplatesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['feeTemplates', search, page, category, pageSize],
    queryFn: () => {
      return privateAxios.get('/billing/fee_templates', {
        params: {
          search,
          page,
          'q[applicable_entity_eq]': category,
          page_size: pageSize,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
